module.exports = __webpack_public_path__ + "img/factory.f7ef33bf.png";